import BaseModel from "../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class NotificationActivitySearch extends BaseModel {
  actions = null;
  type = null;
  created_at = null;
  recipient_email = null;

  rules = {};

  attributeLabels = {
    recipient_email: i18n.t('Recipient Email'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    return data;
  }
}
